import React from "react";
import styles from "./styles.module.css";
import { useWindowDimensions } from "../../../../utils/util";
import graduation_cap from "../../../../assets/icons/graduation-cap-solid.svg";
import class_taken from "../../../../assets/icons/class_learning_from_home_education_icon.svg";
import verified from "../../../../assets/icons/check_checklist_list_mark_ok_icon.svg";
import down_arrow from "../../../../assets/icons/down_arrow_icon.svg";
import notification from "../../../../assets/icons/bell_mobile ui_notification_icon.svg";

import { useDispatch } from "react-redux";
import { getAdminNumbers } from "../../../../store/actions/admin";

const TopWidgets = ({ widgets }) => {
    return (
        <div className={styles.row}>
            {widgets.map((item, index) => (
                <div key={index} className={styles.firstRowTab}>
                    <img src={item.icon} alt="icon" className={styles.widgetIcon} />
                    <div className={styles.widgetTitle}>{item.title}</div>
                    <div className={styles.widgetNumber}>{item.number}</div>
                </div>
            ))}
        </div>
    );
};

const FeeCollection = () => (
    <div className={styles.fee}>
        <div className={styles.secondRowHeadings}>Fee Collection</div>
        <div className={styles.secondRowBody}>Monthly Overview</div>
    </div>
);



const RightAdminCard = () => (
    <div className={styles.rightCard}>
        <div className={styles.rightCardContent}>
            <div style={{ marginTop: "20px" }}><i className="far fa-comment fa-2x" /></div>
            <img src={notification} alt="notification" className={styles.notification} />
            <div style={{ flex: 1 }}></div>
        </div>
    </div>
);

const ApiErrorBox = ({ error }) => (
    <div className={styles.errorBox}>
        <h4>⚠️ 404 Error Detected</h4>
        <div><strong>URL:</strong> {error.url}</div>
        <div><strong>Message:</strong> {error.message}</div>
        <div style={{ marginTop: '10px', fontSize: '0.8rem', opacity: 0.8 }}>The requested admin resource was not found.</div>
    </div>
);

const FinancialOverview = ({ financials }) => {
    return (
        <div className={styles.financialContainer}>
            <div className={styles.secondRowHeadings}>Financial Overview</div>
            <div className={styles.financialGrid}>
                <div className={styles.financialCard}>
                    <div className={styles.financialTitle}>Total Revenue</div>
                    <div className={styles.financialValue}>$ {Number(financials?.totalRevenue || 0).toFixed(2)}</div>
                    <div className={styles.financialSub}>Total collection from students</div>
                </div>
                <div className={styles.financialCard}>
                    <div className={styles.financialTitle}>Teacher Earnings</div>
                    <div className={styles.financialValue}>$ {Number(financials?.totalTeacherEarnings || 0).toFixed(2)}</div>
                    <div className={styles.financialSub}>Gross earnings (before payout fees)</div>
                </div>
                <div className={styles.financialCard}>
                    <div className={styles.financialTitle}>Platform Fees</div>
                    <div className={styles.financialValue} style={{ color: "#5cb85c" }}>$ {Number(financials?.totalPlatformFees || 0).toFixed(2)}</div>
                    <div className={styles.financialSub}>Total platform share (6% + 21%)</div>
                </div>
            </div>
        </div>
    );
};

function AdminDashboard({ socket }) {
    const { width } = useWindowDimensions();
    const dispatch = useDispatch();
    const [numbers, setNumbers] = React.useState({
        totalStudents: 0,
        currentStudents: 0,
        totalTeachers: 0,
        currentTeachers: 0,
        totalCourses: 0,
        visitors: 0,
        financials: {
            totalRevenue: 0,
            totalTeacherEarnings: 0,
            totalPlatformFees: 0
        }
    });

    const [apiError, setApiError] = React.useState(null);

    React.useEffect(() => {

        const fetchNumbers = async () => {
            try {
                const res = await dispatch(getAdminNumbers());
                if (res?.success) {
                    setNumbers(res.data);
                }
            } catch (err) {
                console.error("Failed to fetch admin stats:", err);
                if (err.response?.status === 404) {
                    setApiError({
                        url: err.config?.url,
                        message: err.response?.data?.message || err.message
                    });
                }
            }
        };
        fetchNumbers();
    }, [dispatch]);

    const widgets = [
        { title: "Total Students", icon: graduation_cap, number: numbers.totalStudents },
        { title: "Current Students", icon: class_taken, number: numbers.currentStudents },
        { title: "Total Teachers", icon: verified, number: numbers.totalTeachers },
        { title: "Current Teachers", icon: verified, number: numbers.currentTeachers },
        { title: "Total Courses", icon: graduation_cap, number: numbers.totalCourses },
        { title: "Visitors", icon: notification, number: numbers.visitors },
    ];

    return (
        <main className={styles.mainSection}>
            {apiError && <ApiErrorBox error={apiError} />}
            {width >= 992 ? (

                <>
                    <TopWidgets widgets={widgets} />
                    <div className={styles.dashboardGrid}>
                        <div className={styles.leftColumn}>
                            <FinancialOverview financials={numbers.financials} />
                        </div>
                        <div className={styles.rightColumn}>
                            <RightAdminCard />
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className={styles.mobileWelcome}>Welcome Admin</div>
                    <TopWidgets widgets={widgets.slice(0, 3)} />
                    <FinancialOverview financials={numbers.financials} />
                </>
            )}
        </main>
    );
}
export default AdminDashboard;
